export default __webpack_public_path__ + "0cda0b0ad4ae564051d16efcf651fcec.png";